import { useMemo } from 'react';

import { pluck } from '../../../utils/object';
import { Bonus } from '../lib/bonus';
import { Reaction } from '../lib/reaction';

export const useUniqueReactions = (bonus: Bonus) => {
	return useMemo(() => {
		const shortcodes = [...new Set(bonus.reactions.map(pluck('emoji')))];

		return shortcodes.map((shortcode) => Reaction.fromShortcode(shortcode));
	}, [bonus]);
};
